export const text = {
  header: "Sign Up for Our Newsletter, Offers,",
  span: " promotion and educational contents",
  p: "Join other professional community to stay ahead",
  button: "Subscribe",
};
